module.exports = __webpack_public_path__ + "media/images/photos/gradient3-749e61fd3a083a5466acaee591ac9536.jpg";